module.exports = __webpack_public_path__ + "img/opp-start-calc.aef2f7c7.png";